module.exports = __webpack_public_path__ + "static/media/B447DC.d6359f8b.svg";